module.exports = __webpack_public_path__ + "static/img/LR.933fcb53.svg";